// @flow
import * as React from "react";

import AuthService from "services/auth";

import { Link } from "react-router-dom";

import Navbar from "./Navbar";

import logo from "./logo.svg";

import "./index.scss";

function Header(): React.Node {
  const isAuthenticated = AuthService.isAuthenticated();

  return (
    <header className="Header">
      <nav className="navbar navbar-expand-lg bg-white" data-bs-theme="light">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={logo} width="133" height="20" alt="Vortex Advertising" />
          </Link>

          <button
            type="button"
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target="#navbar"
            aria-controls="navbar"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse" id="navbar">
            {isAuthenticated ? <Navbar.LoggedIn /> : <Navbar.LoggedOut />}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
